module.exports = __webpack_public_path__ + "img/375.908132ce.jpg";